/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      v-if="isShowCategoryList"
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="type !== '1'">我的招标订单</el-breadcrumb-item>
        <el-breadcrumb-item v-if="type == '1'">我的中标订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 3采购商 -->
    <el-row :gutter="20" v-if="type !== '1'">
      <el-col :span="6" class="leftaside">
        <el-menu router class="el-menu-vertical-demo">
          <el-menu-item-group v-for="item in leftMenu" :key="item.id">
            <template slot="title">{{ item.menu }}</template>
            <el-menu-item
              v-for="subMenu in item.sub_menu"
              :key="subMenu.id"
              :index="subMenu.url"
              >{{ subMenu.title }}</el-menu-item
            >
          </el-menu-item-group>
        </el-menu>
      </el-col>

      <el-col :span="17" class="rightaside">
        <router-view></router-view>
      </el-col>
    </el-row>
    <!-- 供应商 -->
    <el-row :gutter="20" v-if="type == '1'">
      <el-col :span="6" class="leftaside">
        <el-menu router class="el-menu-vertical-demo">
          <el-menu-item-group v-for="item in leftMenu2" :key="item.id">
            <template slot="title">{{ item.menu }}</template>
            <el-menu-item
              v-for="subMenu in item.sub_menu"
              :key="subMenu.id"
              :index="subMenu.url"
              >{{ subMenu.title }}</el-menu-item
            >
          </el-menu-item-group>
        </el-menu>
      </el-col>

      <el-col :span="17">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: JSON.parse(localStorage.getItem("userdata")).type,
      isShowCategoryList: true,
      leftMenu: [
        {
          id: 6,
          menu: "招标采购",
          sub_menu: [
            {
              id: 2,
              title: "发起招标",
              url: "/RapidProcurement",
            },
            {
              id: 3,
              title: "我的招标",
              url: "/mypurchase",
            },
            {
              id: 1,
              title: "中标采购订单",
              url: "/mypurchaseRight",
            },
            // { // 后期开放
            //     id:4,
            //     title:'合同管理',
            //     url:'/mycontract',
            // },
          ],
        },
        // {
        //   id: 3,
        //   menu: "个人中心",
        //   sub_menu: [
        //     {
        //       id: 1,
        //       title: "个人信息",
        //       url: "/myInfomation",
        //     },
        //     {
        //       id: 2,
        //       title: "账号安全",
        //       url: "/userCenter?tap=3",
        //     },
        //     // {
        //     //     id:3,
        //     //     title:'绑定授权',
        //     //     url:'/userCenter?tap=4',
        //     // },
        //     {
        //       id: 4,
        //       title: "收货地址",
        //       url: "/address",
        //     },
        //   ],
        // },
      ],
      leftMenu2: [
        {
          id: 3,
          menu: "个人中心",
          sub_menu: [
            {
              id: 6,
              menu: "招商采购",
              sub_menu: [
                {
                  id: 2,
                  title: "我的报价",
                  url: "/procurementList",
                },
                // {
                //     id:3,
                //     title:'我的订单',
                //     url:'/mypurchaseRight',
                // },
                // { // 后期开放
                //     id:4,
                //     title:'合同管理',
                //     url:'/mycontract',
                // },
              ],
            },
            // {
            //   id: 1,
            //   title: "个人信息",
            //   url: "/myInfomation",
            // },
            // {
            //   id: 2,
            //   title: "账号安全",
            //   url: "/userCenter?tap=3",
            // },
            // {
            //     id:3,
            //     title:'绑定授权',
            //     url:'/userCenter?tap=4',
            // },
            // {
            //   id: 4,
            //   title: "收货地址",
            //   url: "/address",
            // },
          ],
        },
      ],
      searchValue: "",
      waitPayList: [],
      waitSendList: [],
      waitGetList: [],
      finishList: [],
      closeList: [],
    };
  },
  watch: {
    $route(to, from) {
      console.log(to.path, "path");
      if (from.path == "/RapidProcurement") {
        // 其他页面不展示全部商品分类

        this.isShowCategoryList = false;
      } else {
        //// 只在首页展示全部商品分类
        this.isShowCategoryList = true;
      }
    },
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //     //   取消订单
    //      cancleOrder() {
    //         this.$confirm('确定取消订单?', '提示', {
    //           confirmButtonText: '确定',
    //           cancelButtonText: '取消',
    //           type: 'warning'
    //         }).then(() => {
    //           this.$message({
    //             type: 'success',
    //             message: '取消成功!'
    //           });
    //         }).catch(() => {
    //           this.$message({
    //             type: 'info',
    //             message: '已取消'
    //           });
    //         });
    //       },
    //     //   移出订单
    //     removeOrder(){
    //         this.$confirm('确定移除订单吗?', '提示', {
    //           confirmButtonText: '确定',
    //           cancelButtonText: '取消',
    //           type: 'warning'
    //         }).then(() => {
    //           this.$message({
    //             type: 'success',
    //             message: '移除成功!'
    //           });
    //         }).catch(() => {
    //           this.$message({
    //             type: 'info',
    //             message: '已移除'
    //           });
    //         });
    //     },
    //    nextEditResource(){
    //        this.$refs.sizeForm.validate((valid) => {
    //           if (valid) {
    //             if(this.sizeForm.checkedBox){
    //                 this.errerInfo=false;
    //                 this.$router.push(`/merchantForm?type=${this.$route.query.type}`)
    //             }else{
    //                 this.errerInfo=true;
    //             }
    //           }
    //         });
    //    }
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
/deep/.el-col-6 {
  width: 14%;
}
.leftaside.el-col.el-col-6 {
  background: white;
  padding: 30px;
  box-sizing: border-box;
  .el-menu {
    border-right: 0px;
    li.el-menu-item-group {
      margin-bottom: 15px;
    }
  }

  /deep/ .el-menu-item-group__title {
    padding: 7px 0 10px 20px;
    line-height: normal;
    font-size: 14px;
    color: #333;
  }
  li.el-menu-item {
    height: 24px;
    line-height: 24px;
    font-size: 12px;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    outline: 0;
    background-color: transparent;
  }
  .el-menu-item.is-active {
    color: #c65442;
  }
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-size: 18px;

  // font-weight: bold;
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #c65442;
  font-weight: bold;
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  font-size: 18px;
  color: #c65442;
  font-weight: bold;
}
.rightaside {
  width: 84% !important;
  background: white;
  margin-left: 15px;
  padding: 20px !important;
  .rightaside_content {
    .headerTitle {
      font-size: 20px;
      height: 40px;
      line-height: 40px;
      color: #666;
    }
    /deep/.el-tabs--border-card {
      border: 0px;
      box-shadow: unset;
      .el-tabs__header {
        font-size: 18px;
        border-bottom: 0px;
        background: white;
        /deep/ .el-tabs__item.is-active {
          font-size: 18px;
          background-color: transparent;
          border-right-color: transparent;
          border-left-color: transparent;
        }
      }
    }
    .search_box {
      text-align: right;
      margin-bottom: 10px;
      .input-with-select.el-input.el-input-group.el-input-group--append {
        width: 40%;
      }
    }
    .orderbox_info {
      // padding: 20px;
      // box-sizing: border-box;
      border: 1px solid#ccc;
      .orderbox_info_header {
        padding: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 16px;
          color: #ff6700;
          margin-bottom: 5px;
        }
        .order_money i {
          font-size: 20px;
          color: #ff6700;
        }
      }
      .order_goods_whole {
        padding: 20px;
        box-sizing: border-box;
        .order_goods {
          margin-bottom: 20px;
          .order_Info_item {
            margin-left: 12px;
          }
        }
        button.el-button.buttonStyle {
          padding: 6px 30px;
          font-size: 12px;
          margin-bottom: 6px;
          margin-left: 0;
        }
        .dangerBg.buttonStyle {
          background-color: #ff6700;
          border-color: #ff6700;
        }
        .el-button--danger.is-plain {
          background: white;
        }
        .el-button--danger:focus,
        .el-button--danger:hover {
          color: white;
          background: #f56c6c;
        }
      }
    }
    .tab_pane_content {
      .noData {
        text-align: center;
        height: 200px;
        line-height: 200px;
      }
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/views/procurementMg/index.vue